import { saveDataSyncObject } from '../LocalStore';

async function updateDSO(DSO, fields, saveToLocal) {
  let updatedDSO = null;
  if (DSO) {
    updatedDSO = {
      ...DSO,
      ...fields
    };
  }
  if (saveToLocal && updatedDSO) {
    await saveDataSyncObject(updatedDSO);
  }
  return Promise.resolve(updatedDSO);
}

export default function updateDSOFieldAndSave(DSO, fields, saveToLocal = true) {
  if (Array.isArray(DSO)) {
    return Promise.all(DSO.map(dso => updateDSO(dso, fields, saveToLocal)));
  }
  if (DSO) {
    return updateDSO(DSO, fields, saveToLocal);
  }
  return Promise.resolve([]);
}
